const ProjectStatusConstants = {
    DRAFT: 0,
    INPROGRESS: 1,
    COMPLETED: 2
}

export default ProjectStatusConstants